import { Injectable } from '@angular/core';
import { ObjectTypes } from '@fi-shared/types';

@Injectable()
export class SharedActionsBaseService {
    constructor() {}

    openUserViewPopup(CreatedByUserId: number) {}
    openUnitViewPopup(unitId: number) {}

    isExtendedSearchEnabled = false;
    openExtendedSearch(objectType: ObjectTypes): Promise<any> {
        return undefined;
    }
}
